import { useLocation, useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/hooks/useAuth";

export function SmartBackButton() {
    const { user, isAdmin, isLibraryOwner } = useAuth();
    const location = useLocation();
    const navigate = useNavigate();

    const dashboardPath = isAdmin ? "/admin" : isLibraryOwner ? "/publisher" : user ? "/dashboard" : "/";
    const hideOnPaths = new Set(["/", "/dashboard", "/publisher", "/admin"]);
    const handleClick = () => {
        const historyIndex = typeof window !== "undefined" && typeof window.history.state?.idx === "number"
            ? window.history.state.idx
            : 0;
        const canGoBack = historyIndex > 0;

        if (canGoBack) {
            navigate(-1);
            return;
        }
        navigate(dashboardPath, { replace: true });
    };

    if (hideOnPaths.has(location.pathname)) {
        return null;
    }

    return (
        <Button
            variant="ghost"
            size="icon"
            className="group h-11 w-11 shrink-0 rounded-full bg-blue-50 text-blue-700 shadow-[0_8px_20px_rgba(37,99,235,0.12)] transition-[transform,opacity,background-color] duration-150 hover:bg-blue-100 active:scale-95"
            onClick={handleClick}
            type="button"
        >
            <ArrowLeft className="h-5 w-5 transition-transform duration-200 ease-out group-hover:-translate-x-1" />
            <span className="sr-only">Go Back</span>
        </Button>
    );
}
